import Link from "next/link";
import { useTranslations } from "next-intl";

export function Footer() {
  const t = useTranslations("nav");
  return (
    <footer className="mt-auto border-t border-ink-border bg-surface">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-10 sm:grid-cols-2 sm:px-6 lg:grid-cols-4">
        <div>
          <p className="font-display text-lg font-semibold text-ivory">edaga<span className="text-green">.events</span></p>
          <p className="mt-3 max-w-xs text-sm leading-6 text-ivory-muted">Verified East African music, sports, culture, and community events worldwide.</p>
        </div>
        <div>
          <p className="font-semibold text-ivory">Discover</p>
          <div className="mt-3 flex flex-col gap-2 text-sm text-ivory-muted">
            <Link href="/music">Music</Link><Link href="/sports">Sports</Link><Link href="/culture">Culture</Link><Link href="/community">Community</Link>
          </div>
        </div>
        <div>
          <p className="font-semibold text-ivory">Account</p>
          <div className="mt-3 flex flex-col gap-2 text-sm text-ivory-muted">
            <Link href="/dashboard/tickets">{t("myTickets")}</Link><Link href="/dashboard/events">{t("myEvents")}</Link><Link href="/submit-event">{t("createEvent")}</Link>
          </div>
        </div>
        <div>
          <p className="font-semibold text-ivory">Legal</p>
          <div className="mt-3 flex flex-col gap-2 text-sm text-ivory-muted"><Link href="/terms">Terms</Link><Link href="/privacy">Privacy</Link></div>
        </div>
      </div>
    </footer>
  );
}
